import React, { type JSX } from "react";

import { type IBodyProps } from "./IBodyProps";

export default ({ mxEvent, ref }: IBodyProps): JSX.Element => {
    const text = mxEvent.getContent().body;
    return (
        <div className="mx_UnknownBody" ref={ref}>
            {text}
        </div>
    );
};
